<div class="auth-wrapper auth-v2" style="background-color: #fff">
    <div class="auth-inner row m-0" style="background-color: #fff">
        <!-- Brand logo -->
        <div class="d-none d-lg-flex col-lg-8  p-0">
            <div class="w-100 d-lg-flex   px-0">
                <img class="img-fluid" src="assets/images/pages/cocolab3.png" alt="Login V2" />
            </div>
        </div>
        <!-- /Brand logo -->

        <!-- Login-->
        <div class="d-flex col-lg-4 auth-bg  px-2 p-lg-1">

            <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <div style="align-content: center; text-align: center;">
                    <a href="javascript:void(0);">
                        <img src="assets/images/pages/cocolab-logo.png" alt="brand-logo" height="250" />
                    </a>
                </div>

                <hr>

                <h2 class="text-center">
                    Registro
                </h2>

                <form [formGroup]="registerForm" (ngSubmit)="onRegister()" class="auth-login-form mt-2">

                    <div class="form-group">
                        <label>Tipo de persona</label>
                        <div class="form-group">
                            <ng-select [items]="selectBasic" bindLabel="type" formControlName="type_person" [ngModel]="selectBasic" (change)="onChange($event)">
                            </ng-select>
                        </div>
                        <span *ngIf="validField('type_person')" class="error">
                             El tipo de persona es requerido
                        </span>
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="login-email">Ciudad</label>
                        <input class="form-control" type="text" placeholder="Ciudad" autofocus tabindex="1" formControlName="city" />
                        <span *ngIf="validField('city')" class="error">
                           La ciudad es requerida
                        </span>
                    </div>

                    <div class="form-group" *ngIf="this.type==2">
                        <label class="form-label" for="login-email">Nombre</label>
                        <input class="form-control" type="text" placeholder="Nombre" autofocus tabindex="1" formControlName="name" />
                        <span *ngIf="validField('name')" class="error">
                            El nombre es requerido
                        </span>
                    </div>

                    <div class="form-group" *ngIf="this.type==2">
                        <label class="form-label" for="login-email">Apellido</label>
                        <input class="form-control" type="text" placeholder="Apellido" tabindex="1" formControlName="last_name" />
                        <span *ngIf="validField('last_name')" class="error">
              El apellido es requerido
            </span>
                    </div>

                    <div class="form-group" *ngIf="this.type==2">
                        <label class="form-label" for="login-email">Cedula</label>
                        <input class="form-control" type="number" placeholder="Cedula" tabindex="1" formControlName="cedula" />
                        <span *ngIf="validField('cedula')" class="error">
              La cedula es requerido
            </span>
                    </div>

                    <!-- <div *ngIf="this.type==2">
                        <label class="form-label" for="login-email">Categorías</label>
                        <div *ngFor="let item of selectsCategories">

                            <input class="check" type="checkbox" [value]="item.id" (change)="onCheckboxChange($event)" />
                            <label class="form-label">   &nbsp;{{item.name}}
              </label><br>
                        </div>
                    </div> -->


                    <div class="form-group" *ngIf="this.type==1">
                        <label class="form-label" for="login-email">Nombre de la compañía</label
            >
            <input
              class="form-control"
              type="text"
              placeholder="Nombre de la compañía"
              tabindex="1"
              formControlName="company_name"
            />
            <span *ngIf="validField('company_name')" class="error">
              El nombre de la compañía es requerido
            </span>
          </div>

          <div class="form-group" *ngIf="this.type==1">
            <label class="form-label" for="login-email">Nit</label>
                        <input class="form-control" type="number" placeholder="Nit" tabindex="1" formControlName="nit" />
                        <span *ngIf="validField('nit')" class="error">
              El nit es requerido
            </span>
                    </div>

                    <div class="form-group" *ngIf="this.type==1">
                        <label class="form-label" for="login-email">Nombre del encargado</label>
                        <input class="form-control" type="text" placeholder="Nombre del encargado" tabindex="1" formControlName="manager_name" />
                        <span *ngIf="validField('manager_name')" class="error">
                El nombre del encargado es requerido
            </span>
                    </div>

                    <div class="form-group" *ngIf="this.type==1">
                        <label class="form-label" for="login-email">Apellido del encargado</label>
                        <input class="form-control" type="text" placeholder="Apellido del encargado" tabindex="1" formControlName="manager_last_name" />
                        <span *ngIf="validField('manager_last_name')" class="error">
                El apellido del encargado es requerido
            </span>
                    </div>

                    <!-- <div class="form-group" *ngIf="this.type==1">
                        <label class="form-label" for="login-email">Categorías</label>

                        <div *ngFor="let item of selectsCategories">

                            <input class="check" type="checkbox" [value]="item.id" (change)="onCheckboxChange($event)" />
                            <label class="form-label">   &nbsp;{{item.name}}
              </label><br>
                        </div>

                        <span *ngIf="validField('manager_name')" class="error">
                El nombre del encargado es requerido
            </span>
                    </div> -->

                    <div class="form-group" *ngIf="this.type==2 || this.type==1">
                        <label class="form-label" for="login-email">Email</label>
                        <input class="form-control" type="email" placeholder="Email" tabindex="1" formControlName="email" />
                        <span *ngIf="validField('email')" class="error">
              El email es requerido
            </span>
                    </div>

                    <div class="form-group" *ngIf="this.type==2 || this.type==1">
                        <div class="d-flex justify-content-between">
                            <label for="login-password">Contraseña</label>
                        </div>

                        <div class="input-group input-group-merge form-password-toggle" *ngIf="this.type==2 || this.type==1">
                            <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password" class="form-control form-control-merge" tabindex="2" placeholder="·········" aria-describedby="login-password" [ngClass]="{
                                    'is-invalid error': submitted && f.password.errors
                                    }" />

                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i>
                </span>
                            </div>
                            <span *ngIf="validField('password')" class="error">
                La contraseña es requerida
              </span>
                        </div>


                        <div class="form-group mt-1" *ngIf="this.type==2 || this.type==1">
                            <label class="form-label">Confirmar contraseña</label>
                            <input tabindex="2" type="password" formControlName="confirmPassword" class="form-control" placeholder="Confirmar contraseña" />


                            <span *ngIf="validPassword()" class="error">
                Las contraseñas no son iguales
              </span>
                        </div>

                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && f.password.errors }">
                            <div *ngIf="f.password.errors.required">
                                Contraseña es requerida
                            </div>
                        </div>
                    </div>
                    <br />
                    <button class="btn btn-primary btn-block" tabindex="4" rippleEffect>
            Registrarse
          </button>
                </form>

                <p class="text-center mt-2">
                    <span>¿Ya tienes una cuenta?</span>
                    <a (click)="registerRouter()">
                        <span style="color: #3ab5fd ;">&nbsp;Volver a Inicio proveedor</span>
                    </a>
                </p>
            </div>
        </div>
        <!-- /Login-->
    </div>
</div>